import React, { useState } from 'react';

import '../Assets/css/custom.css';
import '../Assets/css/w3-css.css';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


const SuccessMSG =  (props) =>{
    return(
    <Modal  
        show={props.ConfirmSuccess}             
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered 
        backdrop="static"
        onHide={props.onHide}
        >
        <Modal.Header >
            <Modal.Title className='hselect' id="contained-modal-title-vcenter">
            <p className='modal-head-f'>{props.head}</p><br/>{props.head2}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        
        <p className='form-h3 form-h2'>{props.contentline1}
         <br/>{props.contentline2}
        </p>
       
        {props.children}
        <Form className="text-center" onSubmit={e => e.preventDefault()}>
            <div className="d-flex justify-content-end">
            <Button type="button" onClick ={props.Close} className="btn-logout " >CLOSE</Button>
            </div>
        </Form>                                   
        </Modal.Body>
        </Modal>
    );
}
export default SuccessMSG;